module.exports = __webpack_public_path__ + "static/media/gas_hover.78a44d6c.svg";